import toast from 'react-hot-toast'

export function showSampleReadonlyToast(onCreateCompany: () => void) {
  toast.custom((t) => (
    <div className={`sample-readonly-toast ${t.visible ? 'enter' : 'exit'}`}>
      <span>This is a read-only sample. Create your own company to start asking your own questions.</span>
      <button
        onClick={() => { toast.dismiss(t.id); onCreateCompany(); }}
        style={{ marginLeft: 12, padding: '4px 10px', background: '#000', color: '#fff', border: 0, borderRadius: 4, cursor: 'pointer', fontWeight: 600 }}
      >
        Create Your Company
      </button>
    </div>
  ), { duration: 6000 })
}

export function showLlmKeyRequiredToast(onOpenSettings: () => void) {
  toast.custom((t) => (
    <div className={`llm-key-toast ${t.visible ? 'enter' : 'exit'}`}>
      <span>Add your AI provider key to analyze your own companies.</span>
      <button
        onClick={() => { toast.dismiss(t.id); onOpenSettings(); }}
        style={{ marginLeft: 12, padding: '4px 10px', background: '#000', color: '#fff', border: 0, borderRadius: 4, cursor: 'pointer', fontWeight: 600 }}
      >
        Open Settings
      </button>
    </div>
  ), { duration: 8000 })
}

// Used when a CTA is temporarily disabled (e.g. new-company creation is paused).
// Kept as a generic toast so any disabled control can share the copy.
export function showCurrentlyDisabledToast() {
  toast('Currently disabled', { id: 'currently-disabled', duration: 2500 })
}

// Generic plain-language error toast. Use for load/network failures the user
// can act on (refresh, retry). No raw error codes — write a real sentence.
export function showErrorToast(message: string) {
  toast.error(message, { duration: 6000 })
}

// Rate-limit (HTTP 429) toast. Reads the Retry-After window when known.
export function showRateLimitToast(retryAfterSeconds?: number) {
  const wait =
    retryAfterSeconds && retryAfterSeconds <= 75
      ? 'Please wait about a minute and try again.'
      : retryAfterSeconds
      ? `Please wait about ${Math.ceil(retryAfterSeconds / 60)} minutes and try again.`
      : 'You are asking questions too quickly. Please wait a moment and try again.'
  const lead = retryAfterSeconds ? "You've asked several questions very quickly. " : ''
  toast.error(`${lead}${wait}`, { duration: 6000 })
}

export { toast }
